<div class="choose-plan container">
  <app-hero-results [content]="content?.fields.hero"></app-hero-results>
  <!-- <h2 class="choose-plan__title">{{ content?.fields.title }}</h2>
    <p class="choose-plan__ingress">{{ content?.fields.igress }}</p> -->

  <app-title-and-ingress-banner
    [content]="content?.fields.titleAndIngress"
    [paddingBottom]="false"
    *ngIf="!hasSubscription"
  ></app-title-and-ingress-banner>

  <app-choose-plan [content]="content?.fields.choosePlan" [hasSubscription]="hasSubscription"></app-choose-plan>
  <app-faq [content]="content?.fields.faq"></app-faq>
  <app-sitra-banner [content]="content?.fields.sitraTips"></app-sitra-banner>
</div>
